






























































































import { defineComponent, PropType } from '@vue/composition-api';
import { Spacing, Size } from '@front-app/components/constants';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { getUsername } from '@front-app/util/user';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import SimpleCard from '../SimpleCard.vue';

export default defineComponent({
	components: {
		SimpleCard,
		UserLink,
		UserAvatar,
	},
	props: {
		isClickable: Boolean,
		isUnread: Boolean,
		title: {
			type: String,
			required: true,
		},
		creator: {
			type: Object as PropType<PartialUser>,
			required: true,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.LOOSE,
		},
		clickableAria: {
			type: String,
			default: '',
		},
		unreadAria: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		if (props.isClickable && !props.clickableAria) {
			// eslint-disable-next-line no-console
			console.error('When using clickable attribute, you must provide cliackable aria for screen readers as well.');
		}
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		return {
			Size,
			// Avatar
			getUsername: getUsernameInternal,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
		};
	},
});
